import { Box, Stack, Typography, useTheme } from '@mui/joy';

const DonorLegend = ({ print }: { print?: boolean }) => {
	const theme = useTheme();
	const legendItems = [
		{
			color: theme.colorSchemes.light.palette.categoryPartyDemocratMen.solidBg,
			label: 'Democratic Men'
		},
		{
			color:
				theme.colorSchemes.light.palette.categoryPartyDemocratWomen.solidBg,
			label: 'Democratic Women'
		},

		{
			color:
				theme.colorSchemes.light.palette.categoryPartyRepublicanWomen.solidBg,
			label: 'Republican Women'
		},
		{
			color:
				theme.colorSchemes.light.palette.categoryPartyRepublicanMen.solidBg,
			label: 'Republican Men'
		}
	];

	return (
		<Stack
			direction='row'
			sx={{
				width: '100%',
				mb: '2rem',
				flexWrap: 'wrap'
			}}
		>
			{legendItems.map(({ color, label }) => (
				<Stack
					key={label}
					direction='row'
					alignItems='center'
					sx={{ flexWrap: 'nowrap', mt: '.5rem' }}
				>
					<Box
						sx={{
							backgroundColor: color,
							borderRadius: '50%',
							width: '14px',
							height: '14px',
							mt: print ? '1rem' : 0,
							mr: '.75rem',
							minWidth: '14px'
						}}
					></Box>
					<Typography
						level='chartSubtitle'
						sx={{ fontSize: '16px', mr: '1.5rem', whiteSpace: 'nowrap' }}
					>
						{label}
					</Typography>
				</Stack>
			))}
		</Stack>
	);
};

export default DonorLegend;
